"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalTreePatchValidationError = exports.GoalTreePatchSchema = exports.GoalTreePatchCommandSchema = exports.GoalTreeEnvelopeSchema = exports.GoalTreeUiHintsSchema = exports.GoalTreeVerificationSchema = exports.GoalTreeNextStepSchema = exports.GoalTreeGapSchema = exports.GoalTreeProgressSchema = exports.GoalTreeNodeSchema = exports.GoalTreeActionSchema = exports.GoalTreeRefSchema = exports.GoalTreeJsonValueSchema = exports.GoalStepModelPolicySchema = exports.GoalTreeInteractionModeSchema = exports.GoalTreeReasoningLevelSchema = exports.GoalTreeModelTierSchema = exports.GoalTreeGapSeveritySchema = exports.GoalTreeNodeStatusSchema = exports.GoalTreeDomainSchema = exports.GOAL_TREE_SCHEMA_VERSION = void 0;
exports.toGoalTreeJsonValue = toGoalTreeJsonValue;
exports.toOptionalGoalTreeJsonValue = toOptionalGoalTreeJsonValue;
exports.assertGoalTreePatchAppliesToTree = assertGoalTreePatchAppliesToTree;
exports.findGoalTreeNode = findGoalTreeNode;
exports.isGoalTreeModelPolicyEditableNode = isGoalTreeModelPolicyEditableNode;
const zod_1 = require("zod");
exports.GOAL_TREE_SCHEMA_VERSION = 1;
exports.GoalTreeDomainSchema = zod_1.z.enum(['custom_app', 'automation']);
exports.GoalTreeNodeStatusSchema = zod_1.z.enum([
    'ready',
    'configured',
    'defaulted',
    'missing',
    'invalid',
    'blocked',
    'running',
    'completed',
]);
exports.GoalTreeGapSeveritySchema = zod_1.z.enum([
    'info',
    'warning',
    'blocking',
]);
exports.GoalTreeModelTierSchema = zod_1.z.enum(['economy', 'standard', 'pro']);
exports.GoalTreeReasoningLevelSchema = zod_1.z.enum([
    'off',
    'low',
    'medium',
    'high',
]);
exports.GoalTreeInteractionModeSchema = zod_1.z.enum(['chat', 'agent']);
exports.GoalStepModelPolicySchema = zod_1.z
    .object({
    defaultTier: exports.GoalTreeModelTierSchema,
    allowedTiers: zod_1.z.array(exports.GoalTreeModelTierSchema).min(1),
    reasoning: exports.GoalTreeReasoningLevelSchema,
    reason: zod_1.z.string().min(1),
    userOverride: zod_1.z
        .object({
        tier: exports.GoalTreeModelTierSchema.optional(),
        reasoning: exports.GoalTreeReasoningLevelSchema.optional(),
        updatedAt: zod_1.z.string().min(1).optional(),
    })
        .strict()
        .optional(),
    costEstimate: zod_1.z
        .object({
        credits: zod_1.z.number().nonnegative().optional(),
        label: zod_1.z.string().min(1).optional(),
    })
        .strict()
        .optional(),
})
    .strict()
    .superRefine((policy, ctx) => {
    if (!policy.allowedTiers.includes(policy.defaultTier)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'defaultTier must be present in allowedTiers',
            path: ['defaultTier'],
        });
    }
});
exports.GoalTreeJsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
    zod_1.z.array(exports.GoalTreeJsonValueSchema),
    zod_1.z.record(exports.GoalTreeJsonValueSchema),
]));
function toGoalTreeJsonValue(value) {
    if (value === null ||
        typeof value === 'string' ||
        typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
    }
    if (Array.isArray(value)) {
        return value
            .filter(item => item !== undefined)
            .map(item => toGoalTreeJsonValue(item));
    }
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value)
            .filter(([, item]) => item !== undefined)
            .map(([key, item]) => [key, toGoalTreeJsonValue(item)]));
    }
    return null;
}
function toOptionalGoalTreeJsonValue(value) {
    return value === undefined ? undefined : toGoalTreeJsonValue(value);
}
exports.GoalTreeRefSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    type: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.GoalTreeActionSchema = zod_1.z
    .object({
    actionId: zod_1.z.string().min(1),
    kind: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    disabledReason: zod_1.z.string().min(1).optional(),
    requiresConfirmation: zod_1.z.boolean().optional(),
})
    .strict();
exports.GoalTreeNodeSchema = zod_1.z.lazy(() => zod_1.z
    .object({
    nodeId: zod_1.z.string().min(1),
    kind: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    status: exports.GoalTreeNodeStatusSchema,
    required: zod_1.z.boolean(),
    valueSummary: zod_1.z.string().min(1).optional(),
    detail: exports.GoalTreeJsonValueSchema.optional(),
    refs: zod_1.z.array(exports.GoalTreeRefSchema).optional(),
    actions: zod_1.z.array(exports.GoalTreeActionSchema).optional(),
    modelPolicy: exports.GoalStepModelPolicySchema.optional(),
    children: zod_1.z.array(exports.GoalTreeNodeSchema),
})
    .strict());
exports.GoalTreeProgressSchema = zod_1.z
    .object({
    ready: zod_1.z.number().int().nonnegative(),
    configured: zod_1.z.number().int().nonnegative(),
    defaulted: zod_1.z.number().int().nonnegative(),
    missing: zod_1.z.number().int().nonnegative(),
    invalid: zod_1.z.number().int().nonnegative(),
    blocked: zod_1.z.number().int().nonnegative(),
    completed: zod_1.z.number().int().nonnegative().optional(),
    total: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.GoalTreeGapSchema = zod_1.z
    .object({
    gapId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    severity: exports.GoalTreeGapSeveritySchema,
    blocking: zod_1.z.boolean(),
    reason: zod_1.z.string().min(1),
    allowedActions: zod_1.z.array(zod_1.z.string().min(1)),
    detail: exports.GoalTreeJsonValueSchema.optional(),
})
    .strict();
exports.GoalTreeNextStepSchema = zod_1.z
    .object({
    nextStepId: zod_1.z.string().min(1),
    nodeId: zod_1.z.string().min(1),
    actionKind: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    requiredConfirmation: zod_1.z.string().min(1).optional(),
    modelPolicy: exports.GoalStepModelPolicySchema.optional(),
})
    .strict();
exports.GoalTreeVerificationSchema = zod_1.z
    .object({
    status: zod_1.z.enum(['not_started', 'running', 'passed', 'failed', 'skipped']),
    checks: zod_1.z.array(zod_1.z
        .object({
        checkId: zod_1.z.string().min(1),
        label: zod_1.z.string().min(1),
        status: zod_1.z.enum([
            'not_started',
            'running',
            'passed',
            'failed',
            'skipped',
        ]),
        reason: zod_1.z.string().min(1).optional(),
    })
        .strict()),
})
    .strict();
exports.GoalTreeUiHintsSchema = zod_1.z
    .object({
    defaultExpandedDepth: zod_1.z.number().int().nonnegative().optional(),
    renderer: zod_1.z.string().min(1).optional(),
    orientation: zod_1.z.enum(['vertical', 'horizontal']).default('vertical'),
    allowUserPatches: zod_1.z.boolean().default(true),
})
    .strict();
exports.GoalTreeEnvelopeSchema = zod_1.z
    .object({
    schemaVersion: zod_1.z.literal(exports.GOAL_TREE_SCHEMA_VERSION),
    domain: exports.GoalTreeDomainSchema,
    interactionMode: exports.GoalTreeInteractionModeSchema.default('agent'),
    mode: zod_1.z.string().min(1),
    target: zod_1.z.record(exports.GoalTreeJsonValueSchema),
    root: exports.GoalTreeNodeSchema,
    progress: exports.GoalTreeProgressSchema,
    gaps: zod_1.z.array(exports.GoalTreeGapSchema),
    nextSteps: zod_1.z.array(exports.GoalTreeNextStepSchema),
    diff: exports.GoalTreeJsonValueSchema.optional(),
    recipe: exports.GoalTreeJsonValueSchema.optional(),
    verification: exports.GoalTreeVerificationSchema.optional(),
    uiHints: exports.GoalTreeUiHintsSchema.default({
        allowUserPatches: true,
        orientation: 'vertical',
    }),
    payload: zod_1.z.record(exports.GoalTreeJsonValueSchema).optional(),
})
    .strict();
exports.GoalTreePatchCommandSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('setNodeValue'),
        nodeId: zod_1.z.string().min(1),
        value: exports.GoalTreeJsonValueSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('acceptDefault'),
        nodeId: zod_1.z.string().min(1),
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('bindEntity'),
        nodeId: zod_1.z.string().min(1),
        entity: exports.GoalTreeRefSchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('setStepModelPolicy'),
        nodeId: zod_1.z.string().min(1),
        policy: exports.GoalStepModelPolicySchema,
    })
        .strict(),
    zod_1.z
        .object({
        type: zod_1.z.literal('approveConfirmation'),
        nodeId: zod_1.z.string().min(1),
        confirmationKey: zod_1.z.string().min(1),
    })
        .strict(),
]);
exports.GoalTreePatchSchema = zod_1.z
    .object({
    goalId: zod_1.z.string().min(1).optional(),
    domain: exports.GoalTreeDomainSchema,
    commands: zod_1.z.array(exports.GoalTreePatchCommandSchema).min(1),
})
    .strict();
class GoalTreePatchValidationError extends Error {
    constructor(message, code, nodeId) {
        super(message);
        this.code = code;
        this.nodeId = nodeId;
        this.name = 'GoalTreePatchValidationError';
    }
}
exports.GoalTreePatchValidationError = GoalTreePatchValidationError;
function assertGoalTreePatchAppliesToTree(tree, patch) {
    const parsedTree = exports.GoalTreeEnvelopeSchema.parse(tree);
    const parsedPatch = exports.GoalTreePatchSchema.parse(patch);
    if (parsedPatch.domain !== parsedTree.domain) {
        throw new GoalTreePatchValidationError(`GoalTree patch domain ${parsedPatch.domain} does not match tree domain ${parsedTree.domain}`, 'goal_tree_patch_domain_mismatch');
    }
    for (const command of parsedPatch.commands) {
        const node = findGoalTreeNode(parsedTree.root, command.nodeId);
        if (!node) {
            throw new GoalTreePatchValidationError(`GoalTree patch references unknown node ${command.nodeId}`, 'goal_tree_patch_unknown_node', command.nodeId);
        }
        if (!isPatchCommandAllowed(parsedTree, node, command)) {
            throw new GoalTreePatchValidationError(`GoalTree patch command ${command.type} is not allowed for node ${command.nodeId}`, 'goal_tree_patch_action_not_allowed', command.nodeId);
        }
    }
}
function findGoalTreeNode(node, nodeId) {
    if (node.nodeId === nodeId)
        return node;
    for (const child of node.children) {
        const found = findGoalTreeNode(child, nodeId);
        if (found)
            return found;
    }
    return null;
}
function isGoalTreeModelPolicyEditableNode(tree, node) {
    if (isStructuralGoalTreeNodeKind(node.kind))
        return false;
    if (node.children.length > 0)
        return false;
    return getGoalTreeNodeExecutableActionKinds(tree, node).size > 0;
}
function isStructuralGoalTreeNodeKind(kind) {
    return (kind === 'automation_goal' ||
        kind === 'automation_phase' ||
        kind === 'missing_runbook' ||
        kind === 'custom_app_goal');
}
function isPatchCommandAllowed(tree, node, command) {
    if (command.type === 'setStepModelPolicy') {
        return isGoalTreeModelPolicyEditableNode(tree, node);
    }
    const allowedActions = getGoalTreeNodeExecutableActionKinds(tree, node);
    const detail = isGoalTreeRecord(node.detail) ? node.detail : {};
    if (command.type === 'approveConfirmation') {
        return (node.status === 'blocked' ||
            allowedActions.has('approveConfirmation') ||
            allowedActions.has('approve_confirmation'));
    }
    if (command.type === 'acceptDefault') {
        return (node.status === 'defaulted' ||
            Object.prototype.hasOwnProperty.call(detail, 'defaultValue') ||
            allowedActions.has('acceptDefault') ||
            allowedActions.has('accept_default'));
    }
    if (command.type === 'bindEntity') {
        return (allowedActions.has('bindEntity') ||
            allowedActions.has('bind_workspace_entity') ||
            allowedActions.has('provide_input'));
    }
    if (command.type === 'setNodeValue') {
        return (node.status === 'missing' ||
            node.status === 'invalid' ||
            node.status === 'defaulted' ||
            allowedActions.has('setNodeValue') ||
            allowedActions.has('set_intent') ||
            allowedActions.has('choose_typed_value') ||
            allowedActions.has('provide_override_reason') ||
            allowedActions.has('provide_input') ||
            allowedActions.has('fix_step'));
    }
    return false;
}
function getGoalTreeNodeExecutableActionKinds(tree, node) {
    return new Set([
        ...(node.actions ?? []).map(action => action.kind),
        ...tree.nextSteps
            .filter(step => step.nodeId === node.nodeId)
            .map(step => step.actionKind),
        ...tree.gaps
            .filter(gap => gap.nodeId === node.nodeId)
            .flatMap(gap => gap.allowedActions),
    ]);
}
function isGoalTreeRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
